<template>
  <div>
    <v-select
      v-model="select"
      :items="monthLists"
      item-text="text"
      item-value="value"
      label="Select"
      persistent-hint
      single-line
      hide-details=""
      outlined
      dense
      :disabled="disabled"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "MonthSelector",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      monthLists: [
        { text: "January", value: 0 },
        { text: "February", value: 1 },
        { text: "March", value: 2 },
        { text: "April", value: 3 },
        { text: "May", value: 4 },
        { text: "June", value: 5 },
        { text: "July", value: 6 },
        { text: "August", value: 7 },
        { text: "September", value: 8 },
        { text: "October", value: 9 },
        { text: "November", value: 10 },
        { text: "December", value: 11 },
      ],
    };
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
  },
};
</script>

<style>
</style>